module.exports = __webpack_public_path__ + "img/49.73a9ef8e.jpg";